import SharedReviewLayoutItem from '../../../../shared/shared-review-layout-item';
import { ReviewSection } from '../../../../shared/shared-review-layout';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

interface ReviewSectionBoxesProps {
  sections: ReviewSection[];
}

export default function ReviewSectionBoxes({
  sections,
}: ReviewSectionBoxesProps) {
  const theme = useTheme();
  const semantic = theme.palette.semantic;
  const thinBorder = `0.5px solid ${semantic.outline.light}`;

  return (
    <Stack gap={2} sx={{ width: '100%' }}>
      {sections.map((section) => {
        const items = (section.leftItems ?? []).filter(
          (item) => item.isVisible !== false
        );
        if (items.length === 0) return null;

        return (
          <Box
            key={section.title}
            sx={{
              border: thinBorder,
              borderRadius: 1,
              overflow: 'hidden',
              backgroundColor: semantic.surface.bg1,
            }}
          >
            <Box
              sx={{
                height: 60,
                p: 2,
                display: 'flex',
                alignItems: 'center',
                borderBottom: thinBorder,
                backgroundColor: semantic.surface.bg2,
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontWeight: 500, color: semantic.text.title2 }}
              >
                {section.title}
              </Typography>
            </Box>
            <Box sx={{ px: 2, py: 1.5 }}>
              {items.map((item, index) => (
                <Stack
                  key={`${item.label || 'item'}-${index.toString()}`}
                  direction="row"
                  alignItems="center"
                  sx={{
                    borderBottom:
                      index < items.length - 1
                        ? `1px solid ${semantic.outline.light}`
                        : 'none',
                  }}
                >
                  <Box sx={{ width: 342, flexShrink: 0, p: 2 }}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 500, color: semantic.text.title2 }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      p: 2,
                      '& .MuiTypography-root': {
                        fontSize: 14,
                        lineHeight: 1.43,
                      },
                    }}
                  >
                    <Grid container>
                      <SharedReviewLayoutItem
                        item={{ ...item, label: undefined }}
                        hasOpposite={false}
                      />
                    </Grid>
                  </Box>
                </Stack>
              ))}
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
}
